import { render, staticRenderFns } from "./ManageRequestsEmptyScreen.vue?vue&type=template&id=9a512dea&scoped=true&"
import script from "./ManageRequestsEmptyScreen.vue?vue&type=script&lang=js&"
export * from "./ManageRequestsEmptyScreen.vue?vue&type=script&lang=js&"
import style0 from "./ManageRequestsEmptyScreen.vue?vue&type=style&index=0&id=9a512dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a512dea",
  null
  
)

export default component.exports